import * as React from 'react';
import {
  createFileRoute,
  Link,
  notFound,
  Outlet,
  useMatchRoute,
  useNavigate,
} from '@tanstack/react-router';
import { ReactNode, useEffect } from 'react';
import { AccordionMenu } from '~/components/ui/layout/navigation/submenu/AccordionMenu';

import { hierarchy2AnalyticsMenu } from '~/lib/fund/hierarchy2AnalyticsMenu';

import { useAuth } from '@clerk/clerk-react';
import { useHierarchyEndpoint } from '~/api/useHierarchyEndpoint';
import UploadOutlined from '@material-symbols/svg-400/outlined/upload_file.svg?react';
import { BasicPage } from '~/components/ui/layout/page/basic/BasicPage';
import { HeaderContainer } from '~/components/ui/layout/page/HeaderContainer';
import { Breadcrumb } from '~/components/ui/layout/navigation/breadcrumb/Breadcrumb';
import { PageTagline } from '~/components/ui/layout/page/PageTagline';
import { canAccess } from '~/utils/rbac';

export const Route = createFileRoute('/_authLayout/analytics')({
  beforeLoad: async () => {
    if (!canAccess('analytics')) {
      throw notFound();
    }
  },
  component: AnalyticsComponent,
});

function AnalyticsComponent() {
  const [_menu, setMenu] = React.useState<ReactNode | null>(null);
  const matchRoute = useMatchRoute();
  const isDashboard = matchRoute({ to: '/analytics' });
  const auth = useAuth();
  const navigate = useNavigate();
  const { fundHierarchy } = useHierarchyEndpoint();
  if (!auth.isSignedIn && auth.isLoaded) {
    navigate({ to: '/sign-in' });
  }
  useEffect(() => {
    if (fundHierarchy) {
      setMenu(
        <>
          <AccordionMenu items={hierarchy2AnalyticsMenu(fundHierarchy)} />
          <Link to="/analytics/upload" className="text-sm pl-1 pt-3">
            <UploadOutlined
              className="text-sm"
              style={{
                fontSize: '1rem',
                height: '1.5em',
                width: '1.5rem',
                marginBottom: '-5px',
                color: 'rgba(0, 0, 0, 0.45)',
                opacity: 0.6,
              }}
            />
            Upload Analytics Data
          </Link>
        </>,
      );
    }
  }, [fundHierarchy]);

  return (
    <BasicPage title="Analytics Dashboard">
      {isDashboard ? <AnalyticsPageContainer /> : <Outlet />}
    </BasicPage>
  );
}

const AnalyticsPageContainer = () => {
  return (
    <>
      <HeaderContainer>
        <Breadcrumb items={[{ name: 'Analytics Dashboard' }]} />
        <PageTagline message="Summary of key fund metrics" />
      </HeaderContainer>
    </>
  );
};
